// extracted by mini-css-extract-plugin
export var arrows = "_5m-5";
export var decrementer = "_5m-9";
export var disabled = "_5m-3";
export var error = "_5m-1";
export var hiddenText = "_5m-a";
export var incrementer = "_5m-8";
export var input = "_5m-7";
export var inputWrapper = "_5m-0";
export var leadingIcon = "_5m-b";
export var readonly = "_5m-2";
export var regular = "_5m-6";
export var small = "_5m-4";